module.exports = __webpack_public_path__ + "static/media/person.4c81d3a2.png";